export const fontSize = {
  X10: '10px',
  X11: '11px',
  X12: '12px',
  X15: '15px',
  X18: '18px',
  X23: '23px',
  X31: '31px',
  X41: '41px',
} as const

export const defaultLineHeight = '1.5em'
